import { EventCardDarkCombinedProps } from '../../molecules/EventCardDark/types';
import { MlbCardCombinedProps } from '../../molecules/MlbCard/types';

export const isMLBCard = (props: EventCardDarkCombinedProps | MlbCardCombinedProps): boolean => 'type' in props;